import { render, staticRenderFns } from "./CatalogSettingsInput.vue?vue&type=template&id=1c75a168&"
import script from "./CatalogSettingsInput.vue?vue&type=script&lang=js&"
export * from "./CatalogSettingsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports